import React from 'react'
import {TEXT, CSS_CLASSES} from "./HeaderConstants";
import "./header.css"

export default function Header(props){
	return(
		<header>
			<div className={"header-left-side-container"}>
				<h1>{TEXT.HEADER_TITLE}</h1>
			</div>
			<div className={CSS_CLASSES.HEADER_RIGHT_SIDE}>
				{props.children}
			</div>
		</header>
	)
}